import React, { SVGProps } from 'react';

// MatchbackIcon's two overlapping circles, drawn natively on an 18px grid so it stays sharp at
// 18x18 instead of being scaled down from 20px.
const MatchbackFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="6.5" cy="9" r="4.5" strokeWidth="1.3" />
    <circle cx="11.5" cy="9" r="4.5" strokeWidth="1.3" />
  </svg>
);

export default MatchbackFilterIcon;
